import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore';
import { layoutActions } from '../../store/layoutStore';
import { isObjectPathDefined } from '../../store/apiWrapper';
import Message from '../common/message';
import PrivateRoute from '../privateRoute';

import ShortReport from './shortReportComponent';
import QuickReport from './quickReportComponent';
import GlobalReport from './globalReportComponent';
import MonitoraReport from './monitoraReportComponent';
import NaturalPersonReport from './naturalPersonReportComponent';
import EconomicGroupReport from './economicGroupReportComponent';
import QuickAddressReportComponent from './quickAddressReportComponent';
import VehicleReport from './vehicleReportComponent';
import ReliabilityReport from './reliabilityReportComponent';
import MirriReport from './mirriReportComponent';
import ESGReport from './esgReportComponent';

import './report.scss';

class ReportComponent extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        //only id or language change
        if ((prevProps.location.pathname.substring(prevProps.location.pathname.lastIndexOf('/') + 1) !== this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/') + 1)
            && prevProps.location.pathname.substring(0, prevProps.location.pathname.lastIndexOf('/')) === this.props.location.pathname.substring(0, this.props.location.pathname.lastIndexOf('/')))
            || this.props.user.language !== prevProps.user.language) {
            this.props.reloadReport()
        }
    }

    render() {
        var agentLanguage = this.props.user.authentication.profile.agentLanguage;
        return (
            <div className="report-container" style={{ fontSize: '.875em' }}>
                <div className="report-sections-wrapper">
                    <div className="no-name">
                        {this.chceckSectionError() &&
                            <Message type='warning' message={<Translate id={"UnhappyUser.ReportSectionsError"} options={{ renderInnerHtml: true }} />} />}
                        <PrivateRoute path={`${this.props.match.url}/global/:id`} component={GlobalReport} />
                        <PrivateRoute path={`${this.props.match.url}/natural/:id`} component={NaturalPersonReport} permission="ReportFO" />
                        <PrivateRoute path={`${this.props.match.url}/economic-group/:id`} component={EconomicGroupReport} permission="EconomicGroupView" />
                        <PrivateRoute path={`${this.props.match.url}/quick/:id`} component={QuickReport} permission="SimpleReport" />
                        <PrivateRoute path={`${this.props.match.url}/quick-address/:id`} component={QuickAddressReportComponent} permission="SimpleReport" />
                        <PrivateRoute path={`${this.props.match.url}/short/:id`} component={ShortReport} />
                        <PrivateRoute path={`${this.props.match.url}/monitora/:id`} component={MonitoraReport} />
                        <PrivateRoute path={`${this.props.match.url}/vehicle/:id`} component={VehicleReport} />
                        <PrivateRoute path={`${this.props.match.url}/reliability/:id`} component={ReliabilityReport} />
                        <PrivateRoute path={`${this.props.match.url}/mirri/:id`} component={MirriReport} />
                        <PrivateRoute path={`${this.props.match.url}/esg/:id`} component={ESGReport} />
                        <div className="disclaimer-wrapper">
                            <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                            <hr className="report-component-hr" style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                            <div className="disclaimer-gray"><Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} /></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    chceckSectionError() {
        var error = false;
        if (isObjectPathDefined(this.props, 'report.sections'))
            this.props.report.sections.forEach(section => {
                if (isObjectPathDefined(section, 'error') && section.error !== null)
                    error = true;
            });
        return error;
    }
}

export default withRouter(connect(
    state => ({ report: state.report, user: state.userContext, layout: state.layout }),
    dispatch => bindActionCreators(Object.assign({}, reportActions, layoutActions), dispatch)
)(ReportComponent));